import React, { createContext, useState } from 'react';

import { BASIC_INITIAL_STATE } from '@usas/ui-web/utils/HttpHelper';

export const OtherOrgUnitChangeHistoryStateContext = createContext();

const INITIAL_STATE = {
  ...BASIC_INITIAL_STATE
};

const OtherOrgUnitChangeHistoryContextProvider = ({ children }) => {
  const stateHook = useState(INITIAL_STATE);

  return (
    <OtherOrgUnitChangeHistoryStateContext.Provider value={stateHook}>
      {children}
    </OtherOrgUnitChangeHistoryStateContext.Provider>
  );
};

export default OtherOrgUnitChangeHistoryContextProvider;